import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  IYoutubeScrapeRequest,
  IYoutubeScrapeResponse,
} from "@shared/lib/types/influencer";
import { DiscoveryService } from "../services/discovery.service";

type ScrapeError = {
  response?: {
    json: () => Promise<{ msg?: string }>;
  };
};

export function useYoutubeScrapeVideos() {
  const {
    mutate: scrapeYoutubeVideos,
    data,
    isLoading,
    isError,
  } = useMutation<IYoutubeScrapeRequest, BackednResponse<IYoutubeScrapeResponse>>(
    {
      mutationFn: async (request) => {
        return (await DiscoveryService.getYoutubeScrapeVideos(request).catch(
          async (err: ScrapeError) => {
            const responseBody = await err.response?.json();
            ToastService.error(responseBody?.msg || "Failed to scrape YouTube videos");
            throw err;
          }
        )) as BackednResponse<IYoutubeScrapeResponse>;
      },
      options: { skipInvalidation: true },
    }
  );

  return {
    scrapeYoutubeVideos,
    data,
    isLoading,
    isError,
  };
}
